import React, { useContext, useState, useEffect } from "react";
import { links } from "../../functions/links";
import { Spinner, PersonasContext, clienteAxios, AuthContext, useHistory } from "../shared/";
import { BotonAgregar } from "../shared/Estilos";
import { Input } from "../shared/FormsElements";
import ListarPersonas from "./ListarPersonas";
import TablaPersonas from "./tablas/TablaPersonas";
import "../shared/styles/ViewContainer.css";

const Personas = (props) => {
  const history = useHistory();
  const authContext = useContext(AuthContext);
  const { usuario } = authContext;
  const personasContext = useContext(PersonasContext);
  const { personas, cargando, obtenerPersonasII } = personasContext;

  const [usuarios, setUsuarios] = useState();
  const [loadingLocal, setLoadingLocal] = useState(null);
  const [lista, setLista] = useState(null);
  const [mostarFormulario, setMostrarFormulario] = useState(null);
  const [consultar, setConsultar] = useState(true);
  const [Seleccionado, setSeleccionado] = useState(null);
  const [inicio, setInicio] = useState(1);

  const [DatosForm, LeerForm] = useState(
    {
      buscar: "",
      estado: usuario.rol == "Precalificador"
        ? "Solicitada"
        : "Todos",
      page: 1,
      paginator: 30
    });

  const { buscar, estado, page, paginator } = DatosForm;

  const onChange = (e) => {
    LeerForm({
      ...DatosForm,
      [e.target.name]: e.target.value,
      page: 1
    });

    setConsultar(true);
  };

  const onClick = (e, value) => {
    switch (e.target.name) {
      case "anterior": {
        if (DatosForm.page !== 1) {
          LeerForm({
            ...DatosForm,
            page: DatosForm.page - 1
          })


          setConsultar(true)
        }
      } break;
      case "siguiente": {
        if (DatosForm.page < lista.paginas) {
          LeerForm({
            ...DatosForm,
            page: DatosForm.page + 1
          })


          setConsultar(true)
        }
      } break;
      case "link": {
        LeerForm({
          ...DatosForm,
          page: value
        })


        setConsultar(true)
      } break;
      case "ver_credito":
        history.push("/creditos/ver/" + value.id);
        break;
    }
  }


  useEffect(() => {
    const Load = async () => {
      const result = await clienteAxios.get("/Persona/getAll", {
        params: { texto: DatosForm.buscar, page: DatosForm.page, paginator: DatosForm.paginator },
      });
      setLista(result.data.personas)
    }

    Load()
  }, [buscar, page])

  useEffect(() => {
    const Load = async () => {
      const result = await clienteAxios.get("/User/getAll");
      setUsuarios(result.data.usuarios)
    }

    Load()
  }, []);

  console.log(lista);
  return (
    <div className="view-container">
      <div className="view-header">
        <h1 className="view-title">Gestionar Clientes</h1>
        <div className="view-toolbar">
          <button
            onClick={() => props.history.push("/clientes/nueva")}
            className="btn-add-primary"
          >
            <i className="fa fa-plus-circle"></i>
            Agregar Cliente
          </button>

          <div className="search-input-container">
            <input
              type="text"
              name="buscar"
              className="search-input"
              placeholder="Buscar cliente por nombre, DNI..."
              value={buscar}
              onChange={onChange}
            />
            <i className="bi bi-search search-icon"></i>
          </div>
        </div>
      </div>

      {loadingLocal && !lista ? (
        <Spinner />
      ) : (
        ""
      )}

      {
        lista
          ? <>
            <div className="pagination-container fade-in">
              <div className="pagination-info">
                Total: {lista.registros} registros
              </div>
              <div className="pagination-buttons">
                <button
                  className="pagination-btn"
                  name="anterior"
                  onClick={(event) => onClick(event)}
                  disabled={lista.pagina === 1}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                {
                  lista.pagina > 2 && (
                    <button
                      className="pagination-btn-outline"
                      name="link"
                      onClick={(event) => onClick(event, 1)}
                    >
                      1
                    </button>
                  )
                }
                {
                  lista.pagina > 3 && <span style={{padding: '0 8px', color: '#9ca3af'}}>...</span>
                }
                {
                  lista.pagina > 1 && (
                    <button
                      className="pagination-btn"
                      name="link"
                      onClick={(event) => onClick(event, lista.pagina - 1)}
                    >
                      {lista.pagina - 1}
                    </button>
                  )
                }
                <button className="pagination-btn pagination-btn-active">
                  {lista.pagina}
                </button>
                {
                  lista.pagina < lista.paginas && (
                    <button
                      className="pagination-btn"
                      name="link"
                      onClick={(event) => onClick(event, lista.pagina + 1)}
                    >
                      {lista.pagina + 1}
                    </button>
                  )
                }
                {
                  lista.pagina < lista.paginas - 2 && <span style={{padding: '0 8px', color: '#9ca3af'}}>...</span>
                }
                {
                  lista.pagina < lista.paginas - 1 && (
                    <button
                      className="pagination-btn-outline"
                      name="link"
                      onClick={(event) => onClick(event, lista.paginas)}
                    >
                      {lista.paginas}
                    </button>
                  )
                }
                <button
                  className="pagination-btn"
                  name="siguiente"
                  onClick={(event) => onClick(event)}
                  disabled={lista.pagina === lista.paginas}
                >
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
            <TablaPersonas
              usuario={usuario}
              usuarios={usuarios}
              lista={lista.personas}
              setSeleccionado={setSeleccionado}
              setMostrarFormulario={setMostrarFormulario}
              setConsultar={setConsultar}
            />
          </>
          : <Spinner />
      }

      { /* cargando ? <Spinner /> : <ListarPersonas personas={personas} />  */}
    </div>
  );
};

export default Personas;
